import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { SystemIntro } from './components/SystemIntro';
import { PainPoints } from './components/PainPoints';
import { PromptExplainer } from './components/PromptExplainer/PromptExplainer';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden text-plum" data-id="element-0" data-mp="2whx95n6vnccj">
      <MetaPixel data-id="element-1" data-mp="28t4lsf4bmctj" />
      <OfferBar data-id="element-2" data-mp="28sl48zil1qg1" />
      {/* Spacer matching the fixed offer bar height */}
      <div className="h-[58px] sm:h-[68px]" aria-hidden="true" style={{
      paddingBottom: "29px"
    }} data-id="element-3" data-mp="23u9qidp62vsj" />
      <main data-id="element-4" data-mp="3iiwasc8k4vxf">
        <Hero data-id="element-5" data-mp="3ijfv1zlojwem" />
        <Stats data-id="element-6" data-mp="3ihv22ef0kliv" />
        <Testimonials data-id="element-7" data-mp="3ii4ppvcl6gle" />
        <SystemIntro data-id="element-8" data-mp="3ml1397n9rmih" />
        <PainPoints data-id="element-9" data-mp="3mkhou0wtvg97" />
        <Volumes data-id="element-10" data-mp="3mjq1tehaqquj" />
        <Bonuses data-id="element-11" data-mp="3mj6ipufwtwex" />
        <Pricing data-id="element-12" data-mp="3rcj5s04xxv5k" />
        <PromptExplainer data-id="element-13" data-mp="3rbzmog3k10py" />
        <FAQ data-id="element-14" data-mp="3rdkkqfp2v1sk" />
        <FinalCTA data-id="element-15" data-mp="3rd19fhtxnbni" />
      </main>
      <Footer data-id="element-16" data-mp="5yh2n2cyzbp" />
    </div>;
}